import * as React from 'react';
import * as styles from './styles.css';

import { InlineText2 } from '@cian/ui-kit/typography';

import { ISuggestion } from '../../../../types/fio';

export interface ISuggestProps {
  suggest: ISuggestion[];
  handleClickItem(value: string): void;
}

export function Suggest({ suggest, handleClickItem }: ISuggestProps) {
  return (
    <div className={styles['fio-suggest']}>
      {suggest.map(item => {
        return (
          <div key={item.value} className={styles['fio-item']} onClick={() => handleClickItem(item.value)}>
            <InlineText2>{item.value}</InlineText2>
          </div>
        );
      })}
    </div>
  );
}
